<div class="form-group mb-2">
  <label for="file" class="camera-info-label">Upload stadium background</label>
    <div class="col col-12 form-control" appImgDroppable (imgUrl)="onImgChange($event)" (click)="fileInput.click()">
      <input type="file" accept=".gif,.jpg,.jpeg,.png" #fileInput (change)="onChange($event)" />
      <i class="icon icon-image" aria-hidden="true"></i>
      <span>{{ file ? file.name : 'Choose a file' }}</span>
    </div>
</div>